import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const HomePageSection = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile,
    isDesktopNavbar
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, Object.assign({
    paddingBlock: isMobile ? '500' : '1000',
    paddingInline: isDesktopNavbar ? '1100' : '300'
  }, rest, {
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: children
    })
  }));
};
export default HomePageSection;